<template>
  <div>
    <div class="row my-2">
      <div class="col-sm-12 col-lg-6 col-md-6">
        <label
          >These are records slated to be Inserted into the users
          database</label
        >
      </div>
      <div class="col-sm-12 col-lg-6 col-md-6 align-right">
        <b-button
          :to="{
            name: previousRoute,
          }"
          pill
          variant="outline-primary"
          >Return To Summary</b-button
        >
      </div>
    </div>
    <div class="row my-1">
      <div class="col-sm-12 col-lg-6 col-md-6 border p-3">
        <label
          >Take Action on Inserts
          <a href="/admin-points-faq">
            <font-awesome-icon icon="question-circle" /> </a
        ></label>

        <br />
        <p class="m-2">Approve these Inserts</p>
        <br />
        <b-button
          class="mx-2"
          @click="insertFinalUsers()"
          pill
          variant="primary"
          >Insert these
          {{ checkModuleInSummaryReturnWithPoints("insert") }} records</b-button
        >
      </div>
    </div>
    <div class="row my-2">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label>Preview insert Records</label>
        <div class="row my-2" v-if="getUsersForPreview.length > 0">
          <div
            class="col-sm-12 col-lg-12 col-md-12 border p-3"
            v-for="User in getUsersForPreview"
            :key="User.upload_id"
          >
            <label
              >{{ User.firstname + " " + User.lastname }} (
              {{ User.username }} ) [
              <b-button
                :to="{
                  name: 'AdminBatchUserUploadToolPreviewInsertUsersEdit',
                  params: {
                    uploadId: +User.upload_id,
                    operationType: User.actiontype,
                    previousRoute: previousRoute,
                    activeMenuItem: activeMenuItem,
                  },
                }"
                pill
                size="sm"
                variant="outline-primary"
                >Edit</b-button
              >
              ]
            </label>
            <div class="row m-1">
              <div class="col-lg-2 col-md-2 border p-1">
                <label>First Name</label>
                <p>{{ User.firstname ? User.firstname : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Last Name</label>
                <p>{{ User.lastname ? User.lastname : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Middle Name</label>
                <p>{{ User.middleinitial ? User.middleinitial : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>User Name</label>
                <p>{{ User.username ? User.username : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Active User</label>
                <p>{{ User.disabled ? "Yes" : "No" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Admin</label>
                <p>{{ User.administrator ? "Yes" : "No" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Single Item</label>
                <p>{{ User.singleitem ? "Yes" : "No" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Points</label>
                <p>{{ User.points ? User.points : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Address</label>
                <p>{{ User.address1 ? User.address1 : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Address 2</label>
                <p>{{ User.address2 ? User.address2 : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>City</label>
                <p>{{ User.city ? User.city : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>State</label>
                <p>{{ User.state ? User.state : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Zip</label>
                <p>{{ User.zip ? User.zip : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Daytime Phone</label>
                <p>{{ User.dayphone ? User.dayphone : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Evening Phone</label>
                <p>{{ User.eveningphone ? User.eveningphone : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Company</label>
                <p>{{ User.company_name ? User.company_name : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Code</label>
                <p>{{ User.code ? User.code : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Code2</label>
                <p>{{ User.code2 ? User.code2 : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1" id="w74">
                <label>Email Address</label>
                <p>{{ User.email ? User.email : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Social Security #</label>
                <p>{{ User.ssn ? User.ssn : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Program</label>
                <p>
                  {{ User.program_name ? User.program_name : "-" }}
                  {{ User.program_id ? `(${User.program_id})` : "" }}
                </p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Transaction Comments</label>
                <p>
                  {{
                    User.transaction_comments ? User.transaction_comments : "-"
                  }}
                </p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Joining Date</label>
                <p>
                  {{ User.joiningdate ? User.joiningdate : "-" }}
                </p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Birth Day</label>
                <p>{{ User.birthday ? User.birthday : "-" }}</p>
              </div>
              <div class="col-lg-2 col-md-2 border p-1">
                <label>Birth Year</label>
                <p>{{ User.birthyear ? User.birthyear : "-" }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-2" v-else>
          <label>No Data Found</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";
import Modal from "@/components/Modal.vue";
import {
  convertToMonthDayYear,
  getCustomizedTimestamp,
} from "@/utilities/date.js";

export default {
  name: "BatchUserUploadToolPreviewInsertUsers",

  props: {
    activeMenuItem: String,
    activeMenu: String,
    previousRoute: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersBatchUserUploadTool",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
    scrollToTOp() {
      window.scrollTo(0, 0);
    },
    checkModuleInSummaryReturnWithPoints(moduleString) {
      if (this.getAllBatchUsersSummary) {
        var point = 0;
        for (var i = 0; i < this.getAllBatchUsersSummary.length; i++) {
          if (this.getAllBatchUsersSummary[i].actionType === moduleString) {
            point = this.getAllBatchUsersSummary[i].total;
            break;
          }
        }
        return point;
      }
    },
    insertFinalUsers() {
      this.$store
        .dispatch("adminBatchUserUploadTool/insertFinalUserRecords")
        .then((status) => {
          // summary update
          this.$router.push({ name: this.previousRoute });
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUserUploadSummary"
          );

          // open modal, show message
          this.$store.dispatch("systemMessage/setModalMessage", {
            message:
              "Your insert data has been finalized. Check user manager to make sure the results are what you intended.",
          });
        })
        .catch(() => {
          console.log("error while insert final users batch user upload");
        });
    },
  },

  computed: {
    getUsersForPreview() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getAllUsersForPreview"
      ];
    },
    getAllBatchUsersSummary() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getAllBatchUserSummary"
      ];
    },
  },

  watch: {},

  created() {
    this.setActiveMenuItem();
    this.scrollToTOp();
    this.$store.dispatch("adminBatchUserUploadTool/fetchUsersForPreview", {
      operationType: "insert",
    });
    this.$store.dispatch("adminBatchUserUploadTool/fetchUserUploadSummary");
  },
};
</script>

<style lang="scss" scoped>
.admin-batch-user-upload-tool {
  margin: -14px 0 0 0;

  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}

#w74 {
  word-wrap: break-word;
}
</style>
